"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _Justification = _interopRequireDefault(require("./Justification"));

var _ITSM = _interopRequireDefault(require("./ITSM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.advanced-settings-header-class {\n  padding-bottom: 2rem; }\n  .advanced-settings-header-class .header-class {\n    margin-top: 2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #a8a8a8; }\n    .advanced-settings-header-class .header-class .margin-top-32 {\n      margin-top: 2rem; }\n    .advanced-settings-header-class .header-class .margin-top-8 {\n      margin-top: 0.5rem; }\n  .advanced-settings-header-class .ITSM-pill-container {\n    display: inline-block;\n    padding: 0.3125rem 0; }\n";
  var fileName = "compone_AdvancedSettings";
  var element = document.querySelector("style[data-sass-component='compone_AdvancedSettings']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function AdvancedSettings(_ref) {
  var settings = _ref.settings;
  var JustificationResponse = settings === null || settings === void 0 ? void 0 : settings.find(function (key) {
    return (key === null || key === void 0 ? void 0 : key.settingsType) === 'JUSTIFICATION';
  });
  var ITSMResponse = settings === null || settings === void 0 ? void 0 : settings.find(function (key) {
    return (key === null || key === void 0 ? void 0 : key.settingsType) === 'ITSM';
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement(_Justification.default, {
    JustificationResponse: JustificationResponse
  }), /*#__PURE__*/_react.default.createElement(_ITSM.default, {
    ITSMResponse: ITSMResponse
  })));
}

AdvancedSettings.propTypes = {
  settings: _propTypes.default.array
};
var _default = AdvancedSettings;
exports.default = _default;